/* global store */
import delegate from 'delegate';
import {
  EXPAND_BUTTON_CLASS,
  CLOSE_EXPAND_BUTTON_CLASS,
  CUSTOM_BUTTON_CLASS,
  CLICK_THROUGH_BUTTON_CLASS,
} from 'Tracking/constants/selectors';

import {
  loadedDataTrackingEvent,
  timelineUpdateTrackingEvent,
  playTrackingEvent,
  pauseTrackingEvent,
  volumeChangeTrackingEvent,
  errorTrackingEvent,
  fullScreenTrackingEvent,
} from 'Tracking/actions/video';

import {
  fireExpandTrackingEvent,
  fireCloseExpandTrackingEvent,
  fireClickTrackingEvent,
} from 'Tracking/actions/button';

import {
  mouseEnterAdTracking,
  mouseLeaveAdTracking,
} from 'Tracking/actions/ad';

import { fireTracking } from 'Tracking/index';

// User Interactions
const CLICK_EVENT = 'click';
const VIDEO_SELECTOR = 'video';

export default (artboardElement = null) => {
  const { rootElement } = store.getState();
  const events = [
    {
      selector: VIDEO_SELECTOR,
      event: 'loadeddata',
      function: loadedDataTrackingEvent,
      useCapture: true,
    }, {
      selector: VIDEO_SELECTOR,
      event: 'timeupdate',
      function: timelineUpdateTrackingEvent,
      useCapture: true,
    }, {
      selector: VIDEO_SELECTOR,
      event: 'play',
      function: playTrackingEvent,
      useCapture: true,
    }, {
      selector: VIDEO_SELECTOR,
      event: 'pause',
      function: pauseTrackingEvent,
      useCapture: true,
    }, {
      selector: VIDEO_SELECTOR,
      event: 'volumechange',
      function: volumeChangeTrackingEvent,
      useCapture: true,
    }, {
      selector: VIDEO_SELECTOR,
      event: 'error',
      function: errorTrackingEvent,
      useCapture: true,
    }, {
      selector: VIDEO_SELECTOR,
      event: 'webkitfullscreenchange',
      function: fullScreenTrackingEvent,
      useCapture: true,
    }, {
      selector: VIDEO_SELECTOR,
      event: 'mozfullscreenchange',
      function: fullScreenTrackingEvent,
      useCapture: true,
    }, {
      selector: VIDEO_SELECTOR,
      event: 'fullscreenchange',
      function: fullScreenTrackingEvent,
      useCapture: true,
    }, {
      selector: `.${EXPAND_BUTTON_CLASS}`,
      event: CLICK_EVENT,
      function: fireExpandTrackingEvent,
      useCapture: false,
    }, {
      selector: `.${CLOSE_EXPAND_BUTTON_CLASS}`,
      event: CLICK_EVENT,
      function: fireCloseExpandTrackingEvent,
      useCapture: false,
    }, {
      selector: `.${CUSTOM_BUTTON_CLASS}`,
      event: CLICK_EVENT,
      function: e => fireClickTrackingEvent(e, 'click'),
      useCapture: false,
    }, {
      selector: `.${CLICK_THROUGH_BUTTON_CLASS}`,
      event: CLICK_EVENT,
      function: e => fireClickTrackingEvent(e, 'click-through'),
      useCapture: false,
    },
  ];

  const eventElement = artboardElement || rootElement;

  const rootDocument = eventElement.ownerDocument;

  [...events].forEach(event => delegate(eventElement, `#${rootElement.id} ${event.selector}`.trim(), event.event, event.function, event.useCapture));

  eventElement.addEventListener('mouseover', mouseEnterAdTracking, false);
  eventElement.addEventListener('mouseleave', mouseLeaveAdTracking, false);

  rootDocument.addEventListener('unload', () => {
    fireTracking('page-unload');
  }, false);
};



// WEBPACK FOOTER //
// ./app/javascript/packs/App/Render/tracking/eventListeners/document.js